@if (isLoading) {
<div class="chat-room-list">
  @for (placeholder of [1, 2, 3]; track placeholder) {
  <div class="chat-room-list__skeleton">
    <div
      [medSkeletonLoading]="true"
      class="chat-room-list__skeleton-avatar"
    ></div>
    <div class="chat-room-list__skeleton-text">
      <div
        [medSkeletonLoading]="true"
        class="chat-room-list__skeleton-line"
      ></div>
      <div
        [medSkeletonLoading]="true"
        class="chat-room-list__skeleton-line chat-room-list__skeleton-line--short"
      ></div>
    </div>
  </div>
  }
</div>
} @else if (!rooms.length) {
<div class="chat-room-list__empty">
  <fa-icon
    [icon]="['fass', 'comments']"
    class="chat-room-list__empty-icon"
  ></fa-icon>
  <p>{{ 'CHAT.NO_CONVERSATIONS' | translate }}</p>
</div>
} @else {
<ul class="chat-room-list" [ngClass]="{ 'chat-room-list--compact': compact }">
  @for (room of rooms; track trackByRoom($index, room)) {
  <li>
    <button
      type="button"
      class="chat-room-list__item"
      [ngClass]="{
        'chat-room-list__item--active': room.id === activeRoomId,
        'chat-room-list__item--unread': room.unreadCount > 0
      }"
      (click)="onSelect(room)"
    >
      <app-avatar-stack
        class="chat-room-list__avatar"
        [profileIds]="avatarIds(room)"
        [totalCount]="room.otherCount"
        [max]="3"
        [size]="40"
        [overlap]="22"
      ></app-avatar-stack>

      <span class="chat-room-list__content">
        <span class="chat-room-list__top">
          <span class="chat-room-list__name">{{ room.displayName }}</span>
          <span class="chat-room-list__time">{{
            room.lastMessageAt | chatTimestamp
          }}</span>
        </span>

        <span class="chat-room-list__bottom">
          <span class="chat-room-list__preview">{{ previewOf(room) }}</span>

          @if (room.status === roomStatus.CLOSED) {
          <fa-icon
            [icon]="['fass', 'lock']"
            class="chat-room-list__closed-icon"
            [title]="'CHAT.CLOSED' | translate"
          ></fa-icon>
          } @else if (room.unreadCount > 0) {
          <span class="chat-room-list__badge">{{ room.unreadCount }}</span>
          }
        </span>
      </span>
    </button>
  </li>
  }
</ul>
}
